module.exports = __webpack_public_path__ + "img/addFilesDialog.75ff2d8f.jpg";